<generic-search-page PageTitle="Agreements" [filters]="filterCategories" [SearchForRows]="searchFn" [EditRow]="editFn" [SearchHistoryType]="searchHistoryType">

  <div class="pull-right" page-controls>
  </div>

  <agreement-search-results results-grid [agreements]="SearchPageComponent()?.data()"
    (onEdit)="SearchPageComponent()?.edit($event)"
    (sortChanged)="SearchPageComponent()?.onSortChange($event)"></agreement-search-results>

</generic-search-page>